import { createRouter, createWebHistory } from 'vue-router';

const SubpageOnlineBooking = () => import('@/online_booking/new/components/SubpageOnlineBooking');
const SubpageEvents = () => import('@/online_booking/new/components/SubpageEvents');
const EventInfo = () => import('@/online_booking/new/components/events/EventInfo');
const SubpageLogin = () => import('@/online_booking/new/components/SubpageLogin');
const SubpageYourPage = () => import('@/online_booking/new/components/SubpageYourPage');
const SubpageMessages = () => import('@/online_booking/new/components/SubpageMessages');
const SubpageVouchers = () => import('@/online_booking/new/components/SubpageVouchers');
const SubpageGiftcards = () => import('@/online_booking/new/components/SubpageGiftcards');
const SubpageOnlineCourses = () => import('@/online_booking/new/components/online_courses/SubpageOnlineCourses');
const BuyOnlineCourse = () => import('@/online_booking/new/components/online_courses/BuyOnlineCourse');
const PublicOnlineCourse = () => import('@/online_booking/new/components/online_courses/PublicOnlineCourse');
const SubpageMemberships = () => import('@/online_booking/new/components/memberships/SubpageMemberships');
const BuyMembershipPlan = () => import('@/online_booking/new/components/memberships/BuyMembershipPlan');
const PublicMembershipPlan = () => import('@/online_booking/new/components/memberships/PublicMembershipPlan');

const routes = [
    { path: '/book/' + permalink, component: SubpageOnlineBooking, name:'online-booking', props: true, meta: { componentName: 'SubpageOnlineBooking' } },
    { path: '/overview/:slug', component: SubpageEvents, name: 'events', meta: { componentName: 'SubpageEvents' } },
    { path: '/overblik/:slug', component: SubpageEvents, name: 'events2', meta: { componentName: 'SubpageEvents' } },
    { path: '/event/:slug', component: EventInfo, props: true, name: 'event', meta: { componentName: 'EventInfo' } },
    { path: '/book/' + permalink + '/center', component: SubpageLogin, name: 'client-login', meta: { componentName: 'SubpageLogin' } },
    { path: '/book/' + permalink + '/your-page', component: SubpageYourPage, name: 'your-page', meta: { componentName: 'SubpageYourPage' } },
    { path: '/book/' + permalink + '/messages', component: SubpageMessages, name: 'secure-messages', meta: { componentName: 'SubpageMessages' } },
    { path: '/vouchers/' + permalink, component: SubpageVouchers, name: 'buy-vouchers', meta: { componentName: 'SubpageVouchers' } },
    { path: '/giftcards/' + permalink, component: SubpageGiftcards, name: 'buy-giftcards', meta: { componentName: 'SubpageGiftcards' } },
    { path: '/courses/:slug', component: SubpageOnlineCourses, name: 'online-courses', meta: { componentName: 'SubpageOnlineCourses' } },
    { path: '/course/:slug/buy', component: BuyOnlineCourse, name: 'buy-online-course', meta: { componentName: 'BuyOnlineCourse' } },
    { path: '/course/:slug/:access_token?', component: PublicOnlineCourse, name: 'online-course', meta: { componentName: 'PublicOnlineCourse' } },
    { path: '/subscriptions/:slug', component: SubpageMemberships, name: 'memberships', meta: { componentName: 'SubpageMemberships' }},
    { path: '/subscription/:slug/buy', component: BuyMembershipPlan, name: 'buy-membership-plan', meta: { componentName: 'BuyMembershipPlan' } },
    { path: '/subscription/:slug/:access_token?', component: PublicMembershipPlan, name: 'membership-plan', meta: { componentName: 'PublicMembershipPlan' } },
];

export const subPageImports = {
    'SubpageOnlineBooking': SubpageOnlineBooking,
    'SubpageEvents': SubpageEvents,
    'SubpageLogin': SubpageLogin,
    'SubpageYourPage': SubpageYourPage,
    'SubpageMessages': SubpageMessages,
    'SubpageVouchers': SubpageVouchers,
    'SubpageGiftcards': SubpageGiftcards,
    'SubpageOnlineCourses': SubpageOnlineCourses,
    'PublicOnlineCourse': PublicOnlineCourse,
    'BuyOnlineCourse': BuyOnlineCourse,
    'SubpageMemberships': SubpageMemberships,
    'PublicMembershipPlan': PublicMembershipPlan,
    'BuyMembershipPlan': BuyMembershipPlan
};

const router = createRouter({
    routes: routes,
    history: createWebHistory(),
});

/*
** If we have no calendars enabled for online-booking, we want to redirect to the next available OB page route
** active_calendar_count, available_routes, available_routes are variables that is set in the blade template
*/
if (active_calendar_count === 0 && window.location.pathname === '/book/' + permalink) {
    // Find route by component name using the meta data
    const routeIndex = routes.findIndex(el => el.meta.componentName === available_routes[0]);

    if (routeIndex !== -1) {
        let url = routes[routeIndex]['path'];

        if (url.includes(':slug')) {
            url = url.replace(':slug', events_overview_slug);
        }

        window.location.replace(url);
    }
}

export default router;